<script>
    import PanelWebApp from "./web/WebApp";
    import PanelMobileApp from "./web/WebApp";

    let defaultApp = PanelWebApp
    if (process.env.VUE_APP_MODULE === 'mobile'){
        defaultApp = PanelMobileApp
    }

    export default defaultApp
</script>

<style>
@font-face {
  font-family: "Montserrat";
  src: url(./assets/fonts/Montserrat-Light.ttf) format("truetype");
  font-display: swap;
}
@font-face {
  font-family: "MontserratSemiBold";
  src: url(./assets/fonts/Montserrat-SemiBold.ttf) format("truetype");
  font-display: swap;
}

@font-face {
    font-family: "PoppinsRegular";
    src: url(./assets/fonts/Poppins-Regular.ttf) format("truetype");
    font-display: swap;
}

@font-face {
    font-family: "PoppinsMedium";
    src: url(./assets/fonts/Poppins-Medium.ttf) format("truetype");
    font-display: swap;
}

@font-face {
    font-family: "PoppinsBold";
    src: url(./assets/fonts/Poppins-Bold.ttf) format("truetype");
    font-display: swap;
}

@font-face {
    font-family: "CaviarDreams";
    src: url(./assets/fonts/CaviarDreams_Bold.ttf) format("truetype");
    font-display: swap;
}

@font-face {
    font-family: "BrandingSF-Black";
    src: url(./assets/fonts/BrandingSF-Black.ttf) format("truetype");
    font-display: swap;
}

@font-face {
    font-family: "BrandingSF";
    src: url(./assets/fonts/BrandingSF-Medium.ttf) format("truetype");
    font-display: swap;
}


</style>